import React from "react";

import { Box, Stack } from "@chakra-ui/react";

import { SectionWithAnswers } from "../../types/ReportFormTypes";
import { ReportFragment } from "../../../../graphql/generated/definitions";

import SectionTitle from "./utils/SectionTitle";
import QuestionReviewDispatch from "../questions/QuestionReviewDispatch";

type SectionFormProps = {
  report: ReportFragment;
  section: SectionWithAnswers;
  path: `sections.${number}`;
  sectionIndex: number;
  children?: React.ReactNode | React.ReactNode[];
};

const SectionForm: React.FC<SectionFormProps> = ({
  report,
  section,
  path,
  sectionIndex,
  children,
}) => {
  return (
    <Box
      as="section"
      aria-labelledby={`${section.id}.title`}
      aria-describedby={`${section.id}.description`}
    >
      <Box className="page-break" />
      <Box>
        <SectionTitle sectionIndex={sectionIndex} section={section} />
      </Box>
      <Stack spacing={["10", "16"]} pt={["10", "16"]}>
        {section.questions.map((question, index) => (
          <QuestionReviewDispatch
            key={question.id}
            question={section.questions[index]}
            report={report}
            path={`${path}.answers.${index}` as const}
            sectionIndex={sectionIndex}
            questionIndex={index}
          />
        ))}
        {children}
      </Stack>
    </Box>
  );
};

export default React.memo(SectionForm);
